import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b5675e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-col flex-no-wrap h-100 overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Video")
const _hoisted_3 = {
  key: 0,
  class: "video-overlay"
}
const _hoisted_4 = { class: "event-spinner-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KioskWaitingRoomOverlay = _resolveComponent("KioskWaitingRoomOverlay")!
  const _component_ContentWrapper = _resolveComponent("ContentWrapper")!
  const _component_app_chip = _resolveComponent("app-chip")!
  const _component_PatientTelehealthHeader = _resolveComponent("PatientTelehealthHeader")!
  const _component_ChatView = _resolveComponent("ChatView")!
  const _component_EventStateSpinner = _resolveComponent("EventStateSpinner")!
  const _component_VideoViewForIonSlides = _resolveComponent("VideoViewForIonSlides")!
  const _component_TelehealthWrapper = _resolveComponent("TelehealthWrapper")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (!_ctx.inRoom())
        ? (_openBlock(), _createBlock(_component_ContentWrapper, {
            key: 0,
            class: "overlay-content-wrapper"
          }, {
            "content-top": _withCtx(() => [
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  _createVNode(_component_KioskWaitingRoomOverlay, {
                    onExit: _ctx.exitCall,
                    isLoading: !_ctx.callOver,
                    failure: null
                  }, null, 8, ["onExit", "isLoading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_TelehealthWrapper, {
        "chat-visible": _ctx.chatVisible,
        "content-id": "video-view"
      }, {
        menu: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_PatientTelehealthHeader, { onExit: _ctx.exitCall }, {
              default: _withCtx(() => [
                (_ctx.inRoom())
                  ? (_openBlock(), _createBlock(_component_app_chip, {
                      key: 0,
                      id: "chat-toggle",
                      onClick: _ctx.toggleChat
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onExit"]),
            _createVNode(_component_ChatView, {
              class: "flex-item-grow m-l-16 m-r-16",
              onSend: _ctx.sendTextMessage,
              onInput: _ctx.singleTyping,
              typing: _ctx.showTypingIndication,
              "chat-items": _ctx.chatItems,
              disabled: !_ctx.remoteConnected(),
              "document-chat-disabled": true
            }, null, 8, ["onSend", "onInput", "typing", "chat-items", "disabled"])
          ])
        ]),
        content: _withCtx(() => [
          _createVNode(_component_VideoViewForIonSlides, {
            onCall: _ctx.enterRoom,
            onEnd: _ctx.exitCall,
            onFlip: _ctx.cycleCamera,
            onToggleVideo: _ctx.toggleVideo,
            onMute: _ctx.toggleMute,
            onChat: _ctx.toggleChat,
            state: _ctx.videoControlState
          }, {
            default: _withCtx(() => [
              (!_ctx.doctorConnected())
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_EventStateSpinner, {
                        textColorLight: "",
                        isLoading: true,
                        loadingIcon: "icon-tele-doc",
                        loadingTitle: this.$mhat('KioskTelehealth.DoctorHasLeftTitle'),
                        loadingMessage: this.$mhat('KioskTelehealth.DoctorHasLeftMessage'),
                        failureIcon: "icon-clinic"
                      }, null, 8, ["loadingTitle", "loadingMessage"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onCall", "onEnd", "onFlip", "onToggleVideo", "onMute", "onChat", "state"])
        ]),
        _: 1
      }, 8, ["chat-visible"])
    ]),
    _: 1
  }))
}